module.exports = __webpack_public_path__ + "static/orange-line-5a8c87c93c8b5f961d62056b1b95ddcd.svg";